import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";

export const INTERNAL_LABEL = { group: "Group", organization: "Organization", private: "Private" };

// Two independent controls (shared visibility model): who inside Top-Recruit + whether this Person's portal sees it.
export function VisibilityControls({ internal, portal, onInternal, onPortal, who = "Person", testPrefix = "vis" }) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <label className="flex items-center gap-1.5 text-xs text-slate-500">Internal visibility
        <Select value={internal} onValueChange={onInternal}>
          <SelectTrigger className="h-8 w-36 bg-white" data-testid={`${testPrefix}-internal`}><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">{Object.entries(INTERNAL_LABEL).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </label>
      <label className="flex items-center gap-1.5 text-xs text-slate-500">
        <Switch checked={portal === "shared_with_person"} onCheckedChange={(c) => onPortal(c ? "shared_with_person" : "internal_only")} data-testid={`${testPrefix}-share`} />
        Share with {who}
      </label>
    </div>
  );
}

export function VisibilityBadges({ item, who = "Person", testId }) {
  const iv = item.internal_visibility || "group";
  const shared = item.portal_visibility === "shared_with_person";
  return (
    <span className="inline-flex gap-1" data-testid={testId}>
      <span className={`text-[10px] font-semibold rounded px-1.5 py-0.5 ${iv === "private" ? "bg-rose-50 text-rose-700" : "bg-slate-100 text-slate-600"}`}>{INTERNAL_LABEL[iv]}</span>
      <span className={`text-[10px] font-semibold rounded px-1.5 py-0.5 ${shared ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>{shared ? `Shared with ${who}` : "Internal Only"}</span>
    </span>
  );
}
